import CommonCss from "lib/common/style.module.scss";

import Css from "./style.module.scss";

import { AutoTooltip, CommentsBlock, ModalWindow } from "lib/common";
import { FaCommentDots } from "react-icons/fa";
import { FiAlertTriangle, FiInfo } from "react-icons/fi";
import { getTextsData } from "selectors/texts";
import { useSelector } from "react-redux";
import CommentTargetTypes from "const/CommentTargetTypes";
import Constants from "const/Constants";
import DateTimeFormats from "const/DateTimeFormats";
import Money from "utils/Money";
import React from "react";
import TransactionTypes from "const/TransactionTypes";
import moment from "moment";

const { EMPTY_PLACEHOLDER } = Constants;

const { DATE_TEXT } = DateTimeFormats;

const CommentsWindow = ({ type: commentsType = CommentTargetTypes.TRANSACTIONS, transaction = {}, onClose }) => {
  const { uiTexts } = useSelector(getTextsData);

  const { id: transactionId, amount, currency, type, timestamp, description } = transaction;

  const withdrawTransaction = type === TransactionTypes.WITHDRAW;

  return (
    <ModalWindow
      enableDefaultEnter
      className={Css.commentsWindow}
      config={{ headerText: uiTexts.comments }}
      iconComponent={FaCommentDots}
      onClose={onClose}>
      <div className={Css.transactionInfo}>
        <div
          className={`${Css.amount} ${CommonCss.coloredNumber}`}
          data-negative={withdrawTransaction ? "" : undefined}>
          {amount ? Money.toMoneyString(amount, currency) : EMPTY_PLACEHOLDER}
        </div>
        <div className={Css.date}>
          {timestamp ? moment.utc(timestamp).format(DATE_TEXT) : ""}
        </div>
        <div className={Css.description}>
          <AutoTooltip className={Css.tooltip} active={!!description}>
            {description ? <FiInfo /> : <FiAlertTriangle className={CommonCss.warningText} />}
            <span>{description || uiTexts.noBankDescriptionOrMemo}</span>
          </AutoTooltip>
        </div>
      </div>
      <CommentsBlock
        type={commentsType}
        id={transactionId}
        className={Css.commentsBlock} />
    </ModalWindow>
  );
};

export default CommentsWindow;
